import React, { useEffect, useState } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';
import { styled } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';

import { GroupNameEditModal } from 'components/molecules/Modal';
import { GroupDetailDashboard } from 'components/organisms/GroupDetails';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import ActivitiesPage from 'pages/Activities';
import TaskPage from 'pages/Tasks';
import FilesPage from 'pages/Files';
import groupService from 'services/group';
import { Container, IconButton, Stack, Tabs, Text } from 'shell/components';

const tabOptions = [
    { key: 'analytics', value: 'Analytics', content: <GroupDetailDashboard /> },
    { key: 'activities', value: 'Activity', content: <ActivitiesPage /> },
    { key: 'tasks', value: 'Task Board', content: <TaskPage /> },
    { key: 'files', value: 'Files', content: <FilesPage /> },
];

const GroupDetailPage = () => {
    const history = useHistory();
    const { id: routeGroupId } = useParams();
    const { isLoading, currentGroup, setCurrentGroupId, updateCurrentGroup } = useUser2();
    const { device } = useViewport();

    const [tab, setTab] = useState(tabOptions[0].key);
    const [dialog, setDialog] = useState({ open: false });

    const handleClickBack = () => {
        history.push('/overview');
        setCurrentGroupId('');
    };

    const updateGroupName = async ({ name }) => {
        updateCurrentGroup({ name });
        await groupService.updateGroup(routeGroupId, { name });
    };

    useEffect(() => {
        if (!isLoading) {
            setCurrentGroupId(routeGroupId);
        }
    }, [isLoading, routeGroupId]);

    useEffect(() => {
        return () => {
            setCurrentGroupId('');
        };
    }, []);

    return isLoading ? (
        <LogoLoading />
    ) : (
        <>
            <Container device={device}>
                <CustomStack spacing={4}>
                    <CustomStack alignItems={'center'} direction={'row'} spacing={2}>
                        <IconButton
                            aria-label={'back'}
                            kind={'arrowLeft'}
                            size={'medium'}
                            variant={'square'}
                            onClick={handleClickBack}
                        />
                        <Text noWrap variant={'h6'} weight={'semibold'}>
                            {currentGroup?.name}
                        </Text>
                        <IconButton
                            aria-label={'edit team name'}
                            kind={'edit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={() => setDialog({ open: true })}
                        />
                    </CustomStack>
                    <Tabs
                        aria-label={'select group detail tab'}
                        options={tabOptions}
                        selected={tab}
                        onChange={setTab}
                    />
                </CustomStack>
            </Container>
            <GroupNameEditModal
                open={dialog.open}
                onClose={() => setDialog({ open: false })}
                onSubmit={updateGroupName}
            />
        </>
    );
};

const CustomStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

export default GroupDetailPage;
